// src/config/profilesConfig.js

export const PROFILES = {
  ROOT: 'Root',
  ADMIN: 'Admin',
  DOCENTE: 'Docente',
  ESTUDIANTE: 'Estudiante'
};

// Tipos de usuario
export const TIPO_USUARIO = {
  SISTEMA: 'SISTEMA',
  COLEGIO: 'COLEGIO'
};

// Configuración para Root del SISTEMA (crea y administra universidades)
const rootSistemaConfig = {
  modules: [
    { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardRoot' },
    { id: 'config-colegio', path: '/colegios', icon: '🏛️', label: 'Universidades', component: 'ConfigColegio' },
    { id: 'perfiles', path: '/perfiles', icon: '🔐', label: 'Perfiles', component: 'Perfiles' },
    { id: 'usuarios', path: '/usuarios', icon: '👥', label: 'Usuarios', component: 'Usuarios' },
  ],
  defaultPath: '/dashboard'
};

// Configuración para Root de la UNIVERSIDAD (personaliza su universidad)
const rootUniversidadConfig = {
  modules: [
    { id: 'usuarios', path: '/usuarios', icon: '👥', label: 'Usuarios', component: 'UsuariosColegio' },
    { id: 'perfiles', path: '/perfiles', icon: '🔐', label: 'Perfiles', component: 'PerfilesColegio' },
    { id: 'configuracion', path: '/configuracion', icon: '⚙️', label: 'Configuración', component: 'ConfiguracionColegio' },
  ],
  defaultPath: '/usuarios'
};

export const profilesConfig = {
  [PROFILES.ROOT]: rootSistemaConfig, // Por defecto, Root del sistema

  [PROFILES.ADMIN]: {
    modules: [
      { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardAdmin' },
      {
        id: 'configuracion-academica',
        path: '/configuracion-academica',
        icon: '⚙️',
        label: 'Configuración',
        component: 'ConfiguracionAcademica',
        subItems: [
          { id: 'cohortes', path: '/configuracion-academica/cohortes', icon: '📋', label: 'Cohortes', component: 'CohortesAdmin' },
          { id: 'programas', path: '/configuracion-academica/programas', icon: '📂', label: 'Programas', component: 'ProgramasAdmin' },
          { id: 'unidades-aprendizaje', path: '/configuracion-academica/unidades-aprendizaje', icon: '📖', label: 'Unidades de Aprendizaje', component: 'UnidadesAprendizajeAdmin' },
          { id: 'carga-academica', path: '/configuracion-academica/carga-academica', icon: '👨‍🏫', label: 'Carga Académica', component: 'CargaFormacionAdmin' },
          { id: 'contenido-programatico', path: '/configuracion-academica/contenido-programatico', icon: '📚', label: 'Contenido Programático', component: 'ContenidoProgramaticoAdmin' },
          { id: 'matriculas', path: '/configuracion-academica/matriculas', icon: '📝', label: 'Matrículas', component: 'MatriculasAdmin' },
          { id: 'contenidos', path: '/configuracion-academica/contenidos', icon: '📊', label: 'Contenidos', component: 'ContenidosAdmin' },
          { id: 'escalas-notas', path: '/configuracion-academica/escalas-notas', icon: '📏', label: 'Escalas de Notas', component: 'EscalasNotasAdmin' },
          { id: 'config-notas', path: '/configuracion-academica/config-notas', icon: '📝', label: 'Configuración de Notas', component: 'ConfigNotasAdmin' },
        ]
      },
      { id: 'inasistencias-reporte', path: '/inasistencias-reporte', icon: '📋', label: 'Inasistencias', component: 'InasistenciasReporteAdmin' },
      { id: 'sabana-notas', path: '/reportes/sabana', icon: '📋', label: 'Planilla de Notas', component: 'SabanaNotasDocente' },
      { id: 'libro-final', path: '/reportes/libro-final', icon: '📕', label: 'Libro Final', component: 'LibroFinalDocente' },
      { id: 'usuarios', path: '/usuarios', icon: '👥', label: 'Usuarios', component: 'UsuariosColegio' },
    ],
    defaultPath: '/dashboard'
  },

  [PROFILES.DOCENTE]: {
    modules: [
      { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardDocente' },
      { id: 'notas', path: '/notas', icon: '📝', label: 'Notas', component: 'NotasDocente' },
      { id: 'inasistencias', path: '/inasistencias', icon: '📋', label: 'Inasistencias', component: 'InasistenciasDocente' },
      { id: 'contenido-programatico', path: '/contenido-programatico', icon: '📚', label: 'Contenido Programático', component: 'ContenidoProgramaticoDocente' },
      { id: 'sabana-notas', path: '/reportes/sabana', icon: '📋', label: 'Planilla de Notas', component: 'SabanaNotasDocente' },
      { id: 'libro-final', path: '/reportes/libro-final', icon: '📕', label: 'Libro Final', component: 'LibroFinalDocente' },
    ],
    defaultPath: '/dashboard'
  },

  [PROFILES.ESTUDIANTE]: {
    modules: [
      { id: 'dashboard', path: '/dashboard', icon: '📊', label: 'Dashboard', component: 'DashboardEstudiante' },
      { id: 'notas', path: '/notas', icon: '📝', label: 'Notas', component: 'NotasEstudiante' },
    ],
    defaultPath: '/dashboard'
  }
};

/**
 * Obtiene los módulos para un rol y tipo de usuario
 * @param {string} role - Rol del usuario (Root, Admin, Docente, Estudiante)
 * @param {string} tipoUsuario - Tipo de usuario (SISTEMA o COLEGIO)
 */
export const getProfileModules = (role, tipoUsuario = TIPO_USUARIO.SISTEMA) => {
  // Caso especial: Root de UNIVERSIDAD tiene módulos diferentes
  if (role === PROFILES.ROOT && tipoUsuario === TIPO_USUARIO.COLEGIO) {
    return rootUniversidadConfig.modules;
  }

  const profile = profilesConfig[role];
  return profile ? profile.modules : profilesConfig[PROFILES.ESTUDIANTE].modules;
};

/**
 * Obtiene la ruta por defecto para un rol y tipo de usuario
 * @param {string} role - Rol del usuario
 * @param {string} tipoUsuario - Tipo de usuario (SISTEMA o COLEGIO)
 */
export const getDefaultPath = (role, tipoUsuario = TIPO_USUARIO.SISTEMA) => {
  // Caso especial: Root de UNIVERSIDAD
  if (role === PROFILES.ROOT && tipoUsuario === TIPO_USUARIO.COLEGIO) {
    return rootUniversidadConfig.defaultPath;
  }

  const profile = profilesConfig[role];
  return profile ? profile.defaultPath : '/home';
};

/**
 * Obtiene el módulo actual basado en la ruta
 * @param {string} pathname - Ruta actual
 * @param {string} role - Rol del usuario
 * @param {string} tipoUsuario - Tipo de usuario
 */
export const getModuleByPath = (pathname, role, tipoUsuario = TIPO_USUARIO.SISTEMA) => {
  const modules = getProfileModules(role, tipoUsuario);
  return modules.find(m => m.path === pathname) || modules[0];
};
